import { RootState } from '../../reducers'

export function copiedDataSelector(state: RootState): string | undefined {
  return state.copy.json
}
